import _Vue from "vue"
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

class SentryPlugin {
  public install(Vue: typeof _Vue) {
    // Only initialize Sentry in production
    if (process.env.NODE_ENV === 'development') {
      console.log('Sentry disabled in development mode');
      // Still add to prototype but log to console instead
      Vue.prototype.$sentry = {
        captureMessage: (message: string, options?: any) => {
          console.warn('[Sentry]', message, options?.extra || '');
        },
        captureException: (error: Error, options?: any) => {
          console.error('[Sentry]', error, options?.extra || '');
        },
      };
      return;
    }

    Sentry.init({
        Vue,
        dsn: "https://1e0e58183f8b4edf9cd042e2965f11e8@o16797.ingest.sentry.io/5818404",
        integrations: [new Integrations.BrowserTracing()],

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,
      });

    // Add Sentry to Vue prototype for easy access
    Vue.prototype.$sentry = {
      captureMessage: Sentry.captureMessage,
      captureException: Sentry.captureException,
    };
  }
}

export default new SentryPlugin() ;
